import React from 'react';
import Bem from 'bemHelper';
import get from 'lodash/get';
import { Trans } from 'helpers/i18n';
import Row, { Col } from 'components/row';
import Button from 'components/button';
import Link from 'components/link';

import links from 'src-sites/bildcontrol/links';

import imgGoogleLinkToLiga from '../assets/imgGoogleLinkToLiga.png';
import imgGoogleLinkToLigaPhone from '../assets/imgGoogleLinkToLiga-phone.png';
import imgGoogleLinkToDomik from '../assets/imgGoogleLinkToDomik.png';
import imgGoogleLinkToDomikPhone from '../assets/imgGoogleLinkToDomik-phone.png';
import imgGoogleLinkToApostrophe from '../assets/imgGoogleLinkToApostrophe.png';
import imgGoogleLinkToApostrophePhone from '../assets/imgGoogleLinkToApostrophe-phone.png';

const bemClasses = new Bem('project');

export default function blockConclusionMain() {
  const { i18n } = this;

  return (
    <>
      <Trans lang="ru">
        <Row {...bemClasses('rowTopic')}>
          <Col {...bemClasses('col')} allPr={0}>
            <div {...bemClasses('text', 'h2')}><h2 children="Из детального отчёта вы узнаете" /></div>
          </Col>
        </Row>
        <Row {...bemClasses('rowItems')} mpColumn>
          <Col {...bemClasses('item')} allPr={0}>
            <div {...bemClasses('itemTopic')}>
              <div {...bemClasses('text', 'h3')}><h3 children="Законна стройка или нет:" /></div>
            </div>
            <ul {...bemClasses('itemList')}>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Соблюдено ли целевое назначение земли"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Соблюдено ли функциональное назначение земли"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Имеет ли застройщик право собственности или аренды земли"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Получил ли застройщик разрешение на строительство или зарегистрировал уведомление для СС1"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Есть ли у генподрядчика лицензия на осуществление строительных работ"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children={'Соответствует ли договор инвестора Закону Украины "Об инвестиционной деятельности"'}
                />
              </li>
            </ul>
          </Col>
          <Col {...bemClasses('item')} allPr={0}>
            <div {...bemClasses('itemTopic')}>
              <div {...bemClasses('text', 'h3')}><h3 children="Можно ли доверять вашему застройщику:" /></div>
            </div>
            <ul {...bemClasses('itemList')}>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Информация об участниках строительства"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Открытость застройщика перед инвесторами"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Награды ЖК или застройщика, публичность руководителей"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Число реализованных застройщиком проектов"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Есть ли у застройщика долгострои или замороженные объекты"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Детальный анализ задержек ввода в эксплуатацию по всем проектам застройщика"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Детальный анализ договора инвестора и юридический анализ схемы привлечения инвестиций"
                />
              </li>
            </ul>
          </Col>
          <Col {...bemClasses('item')} allPr={0}>
            <div {...bemClasses('itemTopic')}>
              <div {...bemClasses('text', 'h3')}><h3 children="Суды, запреты, залог, пострадавшие инвесторы" /></div>
            </div>
            <ul {...bemClasses('itemList')}>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Есть ли отягощения по суду или залогу"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Есть ли у проекта пострадавшие инвесторы"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Информация из реестра судебных решений по судам с инвесторами, ГАСИ, департаментом градостроительства и архитектуры, прокуратурой, СБУ, НАБУ, ГБР"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Информация о налоговом долге Заказчика строительства и Застройщика."
                />
              </li>
            </ul>
          </Col>
        </Row>
        <div {...bemClasses('itemDescription', 'withOutLine')}>
          <p
            {...bemClasses('text', 'description')}
            children="Мы рекомендуем всегда заказывать Детальный отчёт о надёжности новостройки, а не руководствоваться только цифрой Индекса надёжности. Вы получите актуализированные данные и сможете располагать всей доступной на момент оценки информацией, связанной с ЖК."
          />
          <p
            {...bemClasses('text', 'description')}
            children="Отчёт о надёжности новостройки гарантирует объективное отражение ситуации."
          />
        </div>
      </Trans>
      <Trans lang="ua">
        <Row {...bemClasses('rowTopic')}>
          <Col {...bemClasses('col')} allPr={0}>
            <div {...bemClasses('text', 'h2')}><h2 children="З детального звіту ви дізнаєтеся" /></div>
          </Col>
        </Row>
        <Row {...bemClasses('rowItems')} mpColumn>
          <Col {...bemClasses('item')} allPr={0}>
            <div {...bemClasses('itemTopic')}>
              <div {...bemClasses('text', 'h3')}><h3 children="Законна забудова чи ні:" /></div>
            </div>
            <ul {...bemClasses('itemList')}>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Чи дотримано цільове призначення землі"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Чи дотримано функціональне призначення землі"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Чи має забудовник право власності або оренди землі"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Чи отримав забудовник дозвіл на будівництво або зареєстрував повідомлення для СС1"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Чи є у генпідрядника ліцензія на здійснення будівельних робіт"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children={'Чи відповідає договір інвестора Закону України "Про інвестиційну діяльність"'}
                />
              </li>
            </ul>
          </Col>
          <Col {...bemClasses('item')} allPr={0}>
            <div {...bemClasses('itemTopic')}>
              <div {...bemClasses('text', 'h3')}><h3 children="Чи можна довіряти вашому забудовнику:" /></div>
            </div>
            <ul {...bemClasses('itemList')}>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Інформація щодо учасників будівництва"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Відкритість забудовника перед інвесторами"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Нагороди ЖК або забудовника, публічність керівників"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Число реалізованих забудовником проєктів"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Чи є у забудовника довгобуди або заморожені об'єкти"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Детальний аналіз затримок введення в експлуатацію за всіма проєктами забудовника"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Детальний аналіз договору інвестора і юридичний аналіз схеми залучення інвестицій"
                />
              </li>
            </ul>
          </Col>
          <Col {...bemClasses('item')} allPr={0}>
            <div {...bemClasses('itemTopic')}>
              <div {...bemClasses('text', 'h3')}><h3 children="Суди, заборони, застава, постраждалі інвестори" /></div>
            </div>
            <ul {...bemClasses('itemList')}>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Чи є обтяження по суду або заставі"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Чи є у проєкта постраждалі інвестори"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Інформація з реєстру судових рішень по судах з інвесторами, ДАБІ, департаментом містобудування та архітектури, прокуратурою, СБУ, НАБУ, ДБР"
                />
              </li>
              <li {...bemClasses('itemDescription')}>
                <p
                  {...bemClasses('text', 'description')}
                  children="Інформація про податковий борг Замовника будівництва та Забудовника."
                />
              </li>
            </ul>
          </Col>
        </Row>
        <div {...bemClasses('itemDescription', 'withOutLine')}>
          <p
            {...bemClasses('text', 'description')}
            children="Ми рекомендуємо завжди замовляти Детальний звіт про надійність новобудови, а не керуватися тільки цифрою Індексу надійності. Ви отримаєте актуалізовані дані і зможете керуватися всією доступною на момент оцінки інформацією, пов'язаною з ЖК."
          />
          <p
            {...bemClasses('text', 'description')}
            children="Звіт про надійність новобудови гарантує об'єктивне відображення ситуації."
          />
        </div>
      </Trans>
      <div {...bemClasses('linkContainer')}>
        <Link
          {...bemClasses('link', 'toHowWeCalculateScore')}
          builder={links.sectionHowWeCalculateScore}
          builderProps={{ title: i18n('moreAReliabilityIndexAndDetailReport') }}
          external
        >
          <span {...bemClasses('linkContent')}>
            <span {...bemClasses('after')} />
            <span {...bemClasses('text')} children={i18n('moreAReliabilityIndexAndDetailReport')} />
          </span>
        </Link>
      </div>
    </>
  );
}

export function blockConclusionAll(livingComplexData) {
  const { i18n, scrollTo } = this;
  const { advanced_info = {}, display_name } = livingComplexData;
  const complex_forums = get(advanced_info, 'complex_forums.val[0]');
  const images = (
    <>
      <picture>
        <source media="(max-width: 767px)" srcSet={imgGoogleLinkToLigaPhone} />
        <img {...bemClasses('img', 'auto')} src={imgGoogleLinkToLiga} alt="imgGoogleLinkToLiga" loading="lazy" decoding="async" />
      </picture>
      <picture>
        <source media="(max-width: 767px)" srcSet={imgGoogleLinkToDomikPhone} />
        <img {...bemClasses('img', 'auto')} src={imgGoogleLinkToDomik} alt="imgGoogleLinkToDomik" loading="lazy" decoding="async" />
      </picture>
      <picture>
        <source media="(max-width: 767px)" srcSet={imgGoogleLinkToApostrophePhone} />
        <img {...bemClasses('img', 'auto')} src={imgGoogleLinkToApostrophe} alt="imgGoogleLinkToApostrophe" loading="lazy" decoding="async" />
      </picture>
    </>
  );
  const btnToMakeOrder = (
    <Button
      {...bemClasses('btn', 'toMakeOrder')}
      title={`${i18n('get')}${i18n('actualDetailedReport')}`}
      label={`${i18n('get')}${i18n('actualDetailedReport')}`}
      onClick={scrollTo}
    />
  );

  return (
    <>
      <Trans lang="ru">
        <div {...bemClasses('itemDescription', 'withOutLine')}>
          <div {...bemClasses('text', 'h3')}>
            <h3 children="Незаконные новостройки ー бедствия с последствиями. Почему не стоит надеяться на «вдруг все обойдётся» и «со мной этого не случится»?" />
          </div>
        </div>
        <div {...bemClasses('imgContainer')} children={images} />
        <div {...bemClasses('itemDescription', 'withOutLine')}>
          <div {...bemClasses('text', 'h3')}>
            <h3 children="Как ты смотришь на перспективу потерять надежду жить в собственной квартире и проводить время на митингах и в  судах?" />
          </div>
        </div>
        <div {...bemClasses('itemDescription', 'withOutLine')}>
          <p
            {...bemClasses('text', 'description')}
            children="Экспертиза новостроек от проекта BildControl.ua — это быстрый и простой способ узнать всю правду о новом жилом комплексе и его застройщике. 5 минут и полный отчёт о новострое у тебя на почте!"
          />
        </div>
        <ul {...bemClasses('itemList')}>
          <li {...bemClasses('itemDescription')}>
            <p
              {...bemClasses('text', 'description')}
              children="Что по документам?"
            />
          </li>
          <li {...bemClasses('itemDescription', 'withOutLine')}>
            <p
              {...bemClasses('text', 'description')}
              children="Мы уже изучили официальные сайты, госреестры и папки документов в отделах продаж вместо тебя, достали оттуда разрешительные документы и прикрепили их в отчёт."
            />
          </li>
          <li {...bemClasses('itemDescription')}>
            <p
              {...bemClasses('text', 'description')}
              children="Кто застройщик?"
            />
          </li>
          <li {...bemClasses('itemDescription', 'withOutLine')}>
            <p
              {...bemClasses('text', 'description')}
              children="При подготовке отчёта мы изучаем ВСЕ проекты компании, вычисляем долгострои и включаем эту информацию в отчёт. Если застройщик не вводит дома в эксплуатацию, индекс будет низким."
            />
          </li>
          <li {...bemClasses('itemDescription')}>
            <p
              {...bemClasses('text', 'description')}
              children="Почему я могу доверять отчёту?"
            />
          </li>
          <li {...bemClasses('itemDescription', 'withOutLine')}>
            <p
              {...bemClasses('text', 'description')}
              children="Мы не сотрудничаем с застройщиками. Каждый новострой оценивается по единой системе: есть документы — есть баллы, нет документов — нет баллов. Всю информацию берём из открытых официальных источников государственных служб."
            />
          </li>
        </ul>
        <div {...bemClasses('itemDescription', 'withOutLine')}>
          <p
            {...bemClasses('text', 'description')}
            children="Покажи наш отчёт своему юристу — пусть прокомментирует. Сэкономишь и деньги, и время."
          />
        </div>
      </Trans>
      <Trans lang="ua">
        <div {...bemClasses('itemDescription', 'withOutLine')}>
          <div {...bemClasses('text', 'h3')}>
            <h3 children="Незаконні новобудови ー лиха з наслідками. Чому не варто сподіватися на «раптом все обійдеться» і «зі мною цього не станеться»?" />
          </div>
        </div>
        <div {...bemClasses('imgContainer')} children={images} />
        <div {...bemClasses('itemDescription', 'withOutLine')}>
          <div {...bemClasses('text', 'h3')}>
            <h3 children="Як ти дивишся на перспективу втратити надію жити у власній квартирі і проводити час на мітингах і в судах?" />
          </div>
        </div>
        <div {...bemClasses('itemDescription', 'withOutLine')}>
          <p
            {...bemClasses('text', 'description')}
            children="Експертиза новобудов від проєкту BildControl.ua — це швидкий і простий спосіб дізнатися всю правду про новий житловий комплекс та його забудовника. 5 хвилин і повний звіт про новобудову у тебе на пошті!"
          />
        </div>
        <ul {...bemClasses('itemList')}>
          <li {...bemClasses('itemDescription')}>
            <p
              {...bemClasses('text', 'description')}
              children="Що по документам?"
            />
          </li>
          <li {...bemClasses('itemDescription', 'withOutLine')}>
            <p
              {...bemClasses('text', 'description')}
              children="Ми вже вивчили офіційні сайти, держреєстри і папки документів у відділах продажів замість тебе, дістали звідти дозвільні документи та прикріпили їх до звіту."
            />
          </li>
          <li {...bemClasses('itemDescription')}>
            <p
              {...bemClasses('text', 'description')}
              children="Хто забудовник?"
            />
          </li>
          <li {...bemClasses('itemDescription', 'withOutLine')}>
            <p
              {...bemClasses('text', 'description')}
              children="При підготовці звіту ми вивчаємо УСІ проєкти компанії, вираховуємо довгобуди і включаємо цю інформацію до звіту. Якщо забудовник не вводить будинки в експлуатацію, індекс буде низьким."
            />
          </li>
          <li {...bemClasses('itemDescription')}>
            <p
              {...bemClasses('text', 'description')}
              children="Чому я можу довіряти звіту?"
            />
          </li>
          <li {...bemClasses('itemDescription', 'withOutLine')}>
            <p
              {...bemClasses('text', 'description')}
              children="Ми не співпрацюємо з забудовниками. Кожен новобуд оцінюється за єдиною системою: є документи — є бали, немає документів — немає балів. Всю інформацію беремо з відкритих офіційних джерел державних служб."
            />
          </li>
        </ul>
        <div {...bemClasses('itemDescription', 'withOutLine')}>
          <p
            {...bemClasses('text', 'description')}
            children="Покажи наш звіт своєму юристу — нехай прокоментує. Зекономиш і гроші, і час."
          />
        </div>
      </Trans>
      {(complex_forums && display_name) &&
        <div {...bemClasses('itemDescription', 'withOutLine')}>
          <Trans lang="ru">
            <p {...bemClasses('text', 'description')}>
              {`Также, вы можете почитать отзывы о ${display_name} на `}
              <Link
                {...bemClasses('link', 'inline')}
                href={complex_forums}
                title="форум Домика"
                noRedirector
                external
                blank
                inlineBlock
              >
                <span {...bemClasses('linkContent')}>
                  <span {...bemClasses('text')} children="форуме Домика" />
                </span>
              </Link>
            </p>
          </Trans>
          <Trans lang="ua">
            <p {...bemClasses('text', 'description')}>
              {`Також, ви можете почитати відгуки про ${display_name} на `}
              <Link
                {...bemClasses('link', 'inline')}
                href={complex_forums}
                title="форум Доміка"
                noRedirector
                external
                blank
                inlineBlock
              >
                <span {...bemClasses('linkContent')}>
                  <span {...bemClasses('text')} children="форумі Доміка" />
                </span>
              </Link>
            </p>
          </Trans>
        </div>
      }
      <div {...bemClasses('btnContainer')} children={btnToMakeOrder} />
    </>
  );
}
